export function imgUrl(imgName) {
  return require(`../assets/images/${imgName}`)
}
